import { TCoreConfig } from "../types/core";

/**
 * Loader for host configuration.
 * Reads configuration from the window object (e.g., window.__HC__.ibe).
 */
export function loadHostConfig(envConfig: TCoreConfig): Record<string, unknown> {
    // Type assertion needed as window properties are dynamic
    const windowConfig = (window as any)[envConfig.globalVendorNamespace]?.[envConfig.globalAppNamespace] || {};

    // the new config is an complex object with other config objects inside
    // for backward compatibility, we keep other config objects as is
    // and move the ibe config object to the ibe key

    const ibeConfig = Object.keys(windowConfig).reduce((acc, key) => {
        if (typeof windowConfig[key] !== "object" && typeof windowConfig[key] !== "function") {
            acc[key] = windowConfig[key];
        }
        return acc;
    }, {} as Record<string, any>);

    const otherConfigObjects = Object.keys(windowConfig).reduce((acc, key) => {
        if (typeof windowConfig[key] === "object") {
            acc[key] = windowConfig[key];
        }
        return acc;
    }, {} as Record<string, any>);

    return {
        ...otherConfigObjects,
        ibe: ibeConfig,
    };
}
